import { MOLD_NEED_LABEL, type MoldNeed } from './moldApi'

export function MoldReadinessBadge({ item, error = false }: { item?: MoldNeed; error?: boolean }) {
  return <span title={item?.reason} className={`inline-flex rounded px-2 py-1 text-xs ${item?.status === 'printed'
    ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-300'
    : 'bg-gray-100 text-gray-600 dark:bg-zinc-800 dark:text-zinc-300'}`}>
    {item ? MOLD_NEED_LABEL[item.status] : error ? 'Не удалось проверить' : 'Проверяем формы…'}
  </span>
}
